import { Link } from "react-router-dom";
import type { Work } from "@/types/work";
import { TYPE_LABELS } from "@/lib/works";

interface MovieCardProps {
  work: Work;
  showSynopsis?: boolean;
}

export default function MovieCard({ work, showSynopsis = true }: MovieCardProps) {
  return (
    <Link to={`/detail/${work.id}`} className="group block cursor-pointer">
      <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-100 border border-background-200/70 group-hover:border-primary-500/70 transition-colors duration-300">
        <img
          src={work.poster}
          alt={`${work.title} 海报`}
          title={`${work.title} 剧情介绍`}
          className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.05]"
        />
        <div className="absolute inset-0 poster-mask" />
        <div className="absolute top-3 left-3 flex items-center gap-2">
          <span className="px-2 py-[3px] rounded bg-primary-500/95 text-foreground-950 text-[11px] font-medium tracking-wide">
            {TYPE_LABELS[work.type] ?? "作品"}
          </span>
          <span className="px-2 py-[3px] rounded bg-background-50/70 backdrop-blur text-foreground-800 text-[11px]">
            {work.year}
          </span>
        </div>
        <div className="absolute top-3 right-3 flex items-center gap-1 px-2 py-[3px] rounded bg-background-50/80 backdrop-blur">
          <i className="ri-star-fill text-accent-400 text-[11px]" />
          <span className="font-label text-[12px] font-medium text-foreground-900">{work.rating.toFixed(1)}</span>
        </div>
        <div className="absolute inset-x-0 bottom-0 p-3 md:p-4">
          <h3 className="font-heading text-base md:text-lg font-semibold leading-snug text-foreground-950 group-hover:text-primary-300 transition-colors">
            {work.title}
          </h3>
          <p className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] md:text-xs text-foreground-600">
            <span>{work.region}</span>
            <span className="text-background-400">/</span>
            <span>{work.duration}</span>
          </p>
        </div>
      </div>
      {showSynopsis && (
        <p className="mt-3 text-xs md:text-[13px] leading-relaxed text-foreground-600 line-clamp-2">{work.synopsis}</p>
      )}
    </Link>
  );
}